import { render, staticRenderFns } from "./TeamStatusComponent.vue?vue&type=template&id=61c7893d&scoped=true&"
import script from "./TeamStatusComponent.vue?vue&type=script&lang=js&"
export * from "./TeamStatusComponent.vue?vue&type=script&lang=js&"
import style0 from "./TeamStatusComponent.vue?vue&type=style&index=0&id=61c7893d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c7893d",
  null
  
)

export default component.exports